<template>
    <div>
        <canvas 
            :width="`${width}px`" 
            :height="`${height}px`"  
            :class="`chart-${this.id} chart-js`" 
        ></canvas> 
    </div>
</template>


<script>
import {mapMutations, mapGetters} from 'vuex';
import {Chart} from 'chart.js';   
 
const colors = {
    firstMain: '#0e1248a6', 
    secondMain: 'rgba(113, 189, 74, 0.7)', 
    darkgrey: 'rgba(105,105,105)'
}; 

export default {
    name: 'chart',
    props: {
        id: {
            required: true
        },
        labels: {
            required: true
        },
        width: {
            required: true
        },
        height: {
            required: true
        },
        charts: {
            required: false
        },
        options: {
            required: true
        }
    }, 
    data() {
        return {
            chart: null
        }
    },
    computed: {
        ...mapGetters({ 
            activeDataset: 'charts/activeDataset'
        }),
        dataset() {
            return this.activeDataset(this.id)
        }
    }, 
    methods: {
        ...mapMutations({
            setDataset: 'charts/prepareDataset',
            setState: 'charts/setState'
        }),
        init() {  
            this.setDataset({key: this.id});
            this.setCanvas();
        },
        setCanvas() { 
            const element = document.querySelector(`.chart-${this.id}`);
            this.chart = new Chart(element.getContext('2d'), { 
                type: 'bar', 
                data: { 
                    labels: this.labels,
                    datasets: this.getDataset()
                },  
                options: this.options, 
            }); 
        }, 
        getDataset() {
            return this.dataset;
        }
    }, 
    mounted() { 
        this.init();  
    },
    beforeDestroy() {
        this.chart.destroy();
        this.setState({
            key: 'show',
            value: false
        });
    }
}
</script>

<style lang="scss" scoped>
.chart-js { 
    object-fit: cover;
 
    margin-bottom: 30px; 
    margin-right: 30px;
}
</style>